import { render, staticRenderFns } from "./FloatingArrow.vue?vue&type=template&id=600f7bbf&scoped=true"
import script from "./FloatingArrow.vue?vue&type=script&lang=js"
export * from "./FloatingArrow.vue?vue&type=script&lang=js"
import style0 from "./FloatingArrow.vue?vue&type=style&index=0&id=600f7bbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f7bbf",
  null
  
)

export default component.exports